import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {UsersService} from '../../../shared/services/users.service';
import { city, Practice } from '../../../shared/classes/city';
import { office } from '../../../shared/classes/office';
import * as _ from "underscore";
import { User } from '../../../shared/classes/User';
import { ToastrService } from 'ngx-toastr';
import { DataContextService } from '../../../shared/services/data-context.service';
// import { GraphData } from '../../../shared/classes/grphData';
import { ConstantsService } from '../../../shared/services/Constants/constants.service';
import { Observable, Subject, of } from 'rxjs'
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { UserOffices } from '../../../shared/classes/UserOffices';
import { UserPractices } from '../../../shared/classes/UserPractices';
import { Office } from '../../../shared/classes/users';
import { Role } from 'src/app/Enum/role';
import { GraphData } from 'src/app/shared/classes/grphData';
import { HttpParams } from '@angular/common/http';
import { exit } from 'process';
import { stat } from 'fs';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
// import { Role } from '../../../shared/enum/role';
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.less']
})
export class AddUserComponent implements OnInit, OnDestroy {
  MasterList: any;
  public cityData: city[];
  public officeData: any;
  public practiceMasterData: Practice[];
  public practiceData: Practice[];
  public graphData: GraphData[];
  public roleData: any;
  GateFloorData: Array<any> = [];
  GFloorData: Array<any> = [];
  CitySelected: number;
  RoleSelected: number;
  PracticeSelected: number;
  GraphUserSelected: number;
  OfficeSelected: number;
  floorSelected: number;
  GateSelected: number;
  employeeForm: any;
  userNameArray: any[];
  requestorName: any;
  adduserDetails: User;
  employeeId: number;
  search: string;
  val:boolean = false;
  // public graphData: GraphData[];
  public ClientName: Array<any> = [];
  Name: string;
  flag: boolean;
  previous: number;
  isSpinning: boolean;
  selectActiveStatus: { isChecked: boolean } = { isChecked: true };
  selectInActiveStatus: { isChecked: boolean } = { isChecked: false };
  isRequestor: boolean = false ;
  isApprover: boolean = false ;
  isL1: boolean = false ;
  isL2: boolean = false ;
  practiceId: number;
  private service_URL: any;
  typeaheadRequestorLoading: boolean;
  requestorNameDataSource: Observable<any>;
  travellerNameArray: any[];
  requestorNameChanged: boolean = false;
  EmployeeFirstName: string;
  EmployeeLastName: string;
  EmployeeFullName: string;
  EmployeeAlias: string;
  EmployeeEmail: string;
  Department: string;
  office:UserOffices;
  practice:UserPractices;
  UserOffices:UserOffices[];
  UserPractices:UserPractices[];
  selectedWorklocation:Array<any>=[];
  a:Array<any>=[]
  selectedCityId:Array<any>=[];
  selectedPractice:Array<any>=[];
  
  // L1 Approver fields
  L1CitySelected: number;
  L1OfficeSelected: number;
  L1PracticeSelected: number;
  selectedL1City: Array<any> = [];
  selectedL1Worklocation: Array<any> = [];
  selectedL1Practice: Array<any> = [];
  L1cityData: city[];
  L1officeData: any;
  L1practiceData: Practice[];
  
  // L2 Approver fields
  L2CitySelected: number;
  L2OfficeSelected: number;
  L2PracticeSelected: number;
  selectedL2City: Array<any> = [];
  selectedL2Worklocation: Array<any> = [];
  selectedL2Practice: Array<any> = [];
  L2cityData: city[];
  L2officeData: any;
  L2practiceData: Practice[];
  noResultTravelerName: boolean;
  selectAdminRole: { isChecked: boolean } = { isChecked: true };
  selectSuperAdminRole: { isChecked: boolean } = { isChecked: false };
  selectSecuritySupervisorRole: { isChecked: boolean } = { isChecked: false };
  selectUserRole: { isChecked: boolean } = { isChecked: false };
  selectisrequestor: { isChecked: boolean } = { isChecked: false };
  selectisapprover: { isChecked: boolean } = { isChecked: false };
  selectisL1approver: { isChecked: boolean } = { isChecked: false };
  selectisL2approver: { isChecked: boolean } = { isChecked: false };
  private unsubscribe$ =new Subject<void>();
  @ViewChild('addUserForm') adduserform: NgForm;
  prev: any;
  flagval: boolean = true;
  constructor(private _dataContextService: DataContextService, private userService: UsersService, private toast: ToastrService, public modalRef: BsModalRef,private trackeromnitureservice:TrackerOmnitureService) {
    this.adduserDetails = new User();
    this.service_URL = ConstantsService;
    this.UserOffices = new Array<UserOffices>();
    this.UserPractices = new Array<UserPractices>();
    //this.office= new UserOffices();
  }
  

  ngOnInit() {
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('user-add',username);
    this.trackeromnitureservice.trackPage("pageView");

    this.roleData = this.GetRoles();
    this.onTravellerNameSeach();
    this.GetDropdownData();
    this.previous = 1;
    this.flag = false;
    this.isSpinning = false;
    this.Name = "";
  }
  GetRoles()
  {
    return [
      {
        roleId : 1,
        roleName : Role.SuperAdmin
      },
      {
        roleId : 2,
        roleName : Role.Admin
      },
      {
        roleId : 3,
        roleName : Role.SecuritySupervisior
      },
      {
        roleId : 4,
        roleName : Role.User
      },
    ]
  }

  // (change)="Onchange_role(this.selectSecuritySupervisorRole.isChecked)"
  Onchange_role(k)
  {
      if(this.flagval)
      {
        this.prev = k;
        var i,l;
        l=this.selectedWorklocation.length;
        if(this.selectedWorklocation.length!= 0)
          {
            this.flagval = false;
            for(i=0;i<l;i++)
            {
              this.removeOfficeSelected(this.selectedWorklocation[0]);
              this.removeCitySelected(this.selectedCityId[0]);
            }
          }
      }

      if (k==1 || k==2)
      {
        // For Admin and Super Admin - use normal fields, not L1/L2
        this.isApprover = true;
        this.isRequestor = true;
        this.isL1 = false;
        this.isL2 = false;
        this.selectisrequestor.isChecked = true;
        this.selectisapprover.isChecked = true;   
        this.selectisL1approver.isChecked = false;
        this.selectisL2approver.isChecked = false;
        this.showbutton_2()
      }
      else {
        // For User and Security Supervisor - reset to allow L1/L2 selection
        this.isApprover = false;
        this.isRequestor = false;
        this.isL1 = false;
        this.isL2 = false;
        this.selectisrequestor.isChecked = false;
        this.selectisapprover.isChecked = false;
        this.selectisL1approver.isChecked = false;
        this.selectisL2approver.isChecked = false;
      }
  }

  Onchange_practice(k){
    this.practiceId = k;
  }

  showbutton_2()
  {
    if(this.RoleSelected==1 || this.RoleSelected==2)
    {
      return false;
    }

    else
       {
          return true;
       }
  }

  // onCheckboxChange(check : string )
  // {
  //   if(check == 'requestor')
  //   {
  //     if(this.isRequestor)
  //     {
  //       this.isRequestor = false;
  //     }
  //     else{
  //       this.isRequestor = true;
  //     }
  //     if(this.isRequestor==true && this.RoleSelected==4){
  //       this.removeCitySelected(this.selectedCityId[0]);
  //       this.removeOfficeSelected(this.selectedWorklocation[0]);
  //       this.selectedCityId = [];
  //       this.selectedWorklocation = [];
  //     }
  //   }
  //   else{
  //     if(this.isApprover)
  //     {
  //       this.isApprover = false;
  //       this.resetApproverValues();
  //     }
  //     else{
  //       this.isApprover = true;
  //     }    
  //   }
   
  // }
  onCheckboxChange(check: string): void {
    if (check === 'requestor') {
      this.isRequestor = !this.isRequestor;
  
      if (this.isRequestor && this.RoleSelected === 4) {
        // Reset city and work locations when "Requestor" is checked
        this.resetCityAndWorkLocations();
      }
    } else if (check === 'approver') {
      this.isApprover = !this.isApprover;
  
      if (!this.isApprover) {
        // Reset city and work locations when "Approver" is unchecked
        this.resetCityAndWorkLocations();
        this.resetApproverValues();
      }
    }
  }

  resetCityAndWorkLocations(): void {
    this.CitySelected = null;
    this.selectedCityId = [];
    this.selectedWorklocation = [];
  
    // Reset cityData and officeData dropdowns
    this.cityData = [...this.MasterList.cityList]; // Reset to the original city list
    this.officeData = []; // Clear work locations
  }
  // resetApproverValues(): void {
  //   if (!this.isApprover) {
  //     this.isL1 = false;
  //     this.isL2 = false;
  //   }
  // }

  resetApproverValues(): void {
    this.isL1 = false;
    this.isL2 = false;
  }
  onApproverChange(check : string)
  {
    if(check == 'L1')
  {
    if(this.isL1)
       {
         this.isL1 = false;
       }
       else{
         this.isL1 = true;
       }
    }
    else{
      if(this.isL2)
      {
        this.isL2 = false;
      }
      else{
        this.isL2 = true;
      }    
    }
   
  }
  selectRole()
  {
     //console.log(this.RoleSelected);
  }
  selectPractice()
  {
    let item = this.practiceData.find(x => x.practiceId == this.PracticeSelected);
    if(item && this.selectedPractice.indexOf(item) === -1) {
      this.selectedPractice.push(item);
      this.practiceData = this.practiceData.filter(x => x.practiceId != item.practiceId).sort((item1, item2) => (item1.name < item2.name) ? -1 : 1);
    }
    this.PracticeSelected = null;
  }
  
  removePracticeSelected(item) {
    this.selectedPractice = this.selectedPractice.filter(x => x.practiceId !== item.practiceId);
    this.practiceData.push(item);
    this.practiceData = this.practiceData.sort((item1, item2) => (item1.name < item2.name) ? -1 : 1);
  }
  selectWorlLocation(){
    // if(this.RoleSelected ==3)
    {
      let item=this.officeData.find(x=>x.officeID==this.OfficeSelected);
      this.selectedWorklocation.push(item);
      this.officeData=this.officeData.filter(x=>x.officeID!=item.officeID).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
      this.flag= false;
      this.previous = 3;
    }
    // else
    // {
    //   let item=this.officeData.find(x=>x.officeID==this.OfficeSelected);
    // }
    
      
  }
  // selectWorlLocation_1(){
    
  //   //this.selectedWorklocation.push(item);
  //   // this.officeData = this.MasterList.officeList.filter((item) => {
  //   //   return item.cityID === this.CitySelected
  //   // }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
  //   // //this.officeData=this.officeData.filter(x=>x.officeID!=item.officeID).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
  //   //console.log(item);
  
  // }
  removeOfficeSelected(item): void {
    // Remove the selected work location
    this.selectedWorklocation = this.selectedWorklocation.filter(x => x.officeID !== item.officeID);
  
    // Add the removed work location back to the officeData array
    this.officeData.push(item);
    this.officeData.sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  
    // Check if there are no remaining work locations for the city
    const cityHasWorkLocations = this.selectedWorklocation.some(worklocation => 
      worklocation.cityID === item.cityID
    );
  
    // If no work locations are left for the city, remove the city
    if (!cityHasWorkLocations) {
      const cityToRemove = this.selectedCityId.find(city => city.cityID === item.cityID);
      if (cityToRemove) {
        this.removeCitySelected(cityToRemove);
      }
    }
  }
  
  removeCitySelected(item):void{
    this.selectedWorklocation = this.selectedWorklocation.filter(x => x.cityID != item.cityID);

    this.selectedCityId=this.selectedCityId.filter(x=>x.cityID!=item.cityID);
    this.cityData.push(item);
    this.cityData.sort((item1,item2)=>(item1.cityName < item2.cityName)?-1:1);

    this.officeData = this.MasterList.officeList
    .filter((office) => this.selectedCityId.some(city => city.cityID === office.cityID))
    .filter((office) => !this.selectedWorklocation.some(worklocation => worklocation.officeID === office.officeID)) // Exclude already added work locations
    .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));

    this.selectedWorklocation = this.selectedWorklocation.filter(worklocation =>
      this.selectedCityId.some(city => city.cityID === worklocation.cityID)
    );
  }
 
  selectCity() {
    let item = this.cityData.find(x => x.cityID == this.CitySelected);
  
    // Restrict multi-city selection for "Shift Supervisor" and "User Requestor" roles
    if (this.RoleSelected === 3 || (this.RoleSelected === 4 && this.isRequestor == true && this.isApprover == false)) { 
      // Role ID 3: Shift Supervisor, Role ID 4: User Requestor
      if (this.selectedCityId.length > 0) {
        // Add the previously selected city back to the dropdown
        const previousCity = this.selectedCityId[0];
        if (!this.cityData.some(x => x.cityID === previousCity.cityID)) {
          this.cityData.push(previousCity);
          this.cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1)); // Sort dropdown alphabetically
        }
      }
  
      this.selectedCityId = []; // Clear existing cities
      this.selectedWorklocation = []; // Clear existing work locations
      if (item) {
        this.selectedCityId.push(item); // Add the newly selected city
      }
    } else {
      // Allow multiple cities for other roles
      if (item && this.selectedCityId.indexOf(item) === -1) {
        this.selectedCityId.push(item);
      }
    }
  
    // Remove the newly selected city from the cityData array
    if (this.cityData && Array.isArray(this.cityData)) {
      // Remove undefined entries from cityData
      this.cityData = this.cityData.filter(x => x !== undefined);
  
      console.log('CitySelected:', this.CitySelected);
      console.log('Filtered cityData:', this.cityData);
  
      // Ensure CitySelected matches cityID type
      const citySelectedNumber = Number(this.CitySelected); // Convert to number if needed
      this.cityData = this.cityData
        .filter(x => x.cityID !== citySelectedNumber)
        .sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
    } else {
      console.warn('cityData is undefined or not an array. Ensure it is initialized properly.');
    }
  
    // Update officeData based on selected cities
    this.officeData = this.MasterList.officeList
      .filter((office) => this.selectedCityId.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedWorklocation.some(worklocation => worklocation.officeID === office.officeID)) // Exclude already added work locations
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }
  
  //Will search based on the value entered for UserName
  searchClient(val) {
    if (val.length > 2) {
      this.flag = true;
      this.isSpinning = true;    
      let url = this.service_URL.Users.graphApi + '?key=' +val;
      
      this._dataContextService.get<any>(url)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        this.graphData = res;
        this.ClientName = this.graphData;
        //console.log(res);
        this.isSpinning = false;
      })
    }
    else {
      this.isSpinning = false;
    }
  }

  //Will trigger after selecting the user from dropdown
  onselectClient(ClientObj) {
    console.log('onselectClient called with:', ClientObj);
    
    this.Name = ClientObj.displayName;
    this.flag = false;
    this.isSpinning = false;
    this.adduserDetails.EmailId = ClientObj.mail ? ClientObj.mail.toLowerCase() : '';
    var fullname = ClientObj.displayName;
    
    // Handle different name formats
    if(fullname) {
      if(fullname.includes(',')) {
        // Format: "LastName, FirstName"
        let value = fullname.split(",");
        this.adduserDetails.FirstName = value[1] ? value[1].trim() : '';
        this.adduserDetails.LastName = value[0] ? value[0].trim() : '';
      } else {
        // Format: "FirstName LastName" or single name
        let value = fullname.trim().split(" ");
        this.adduserDetails.FirstName = value[0] || '';
        this.adduserDetails.LastName = value.length > 1 ? value.slice(1).join(" ") : '';
      }
    }
    
    console.log('After parsing - EmailId:', this.adduserDetails.EmailId);
    console.log('After parsing - FirstName:', this.adduserDetails.FirstName);
    console.log('After parsing - LastName:', this.adduserDetails.LastName);
    
    var empId = ClientObj.employeeId;
    
  }

  //To load cities data 
  GetDropdownData() {
    this.userService.getMastersData()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data) => {
      this.MasterList = data;
      this.cityData = this.MasterList.cityList;
      this.practiceMasterData = this.MasterList.practiceList;
      this.practiceData = this.MasterList.practiceList.filter(practice => practice.practiceId !== 0);
      
      // Initialize L1 and L2 dropdown data
      this.L1cityData = [...this.MasterList.cityList];
      this.L1practiceData = this.MasterList.practiceList.filter(practice => practice.practiceId !== 0);
      this.L2cityData = [...this.MasterList.cityList];
      this.L2practiceData = this.MasterList.practiceList.filter(practice => practice.practiceId !== 0);
    })
  }

  //On city change will load office data
  OnchangeCity(event) {
    
    if(this.CitySelected == null)
    {
      var tempo : Array<any>=[];
      var temp : Array<any>=[];
      let i=0;
      for(i=0;i<this.selectedCityId.length;i++){
        tempo= this.MasterList.office.filter((item) => {
          return item.cityId === this.selectedCityId[i].cityId
        });

        // temp.concat(tempo);
         temp = temp.concat(tempo);
  
      }
      this.officeData =   temp.sort((item1,item2)=>(item1.displayName < item2.displayName)?-1:1);
      
    }
    let i=0;
    var l=this.selectedWorklocation.length;
    for(i=0;i<l;i++)
    {
    //  this.removeOfficeSelected(this.selectedWorklocation[0]);
    }
    this.officeData = this.MasterList.officeList.filter((item) => {
      return item.cityID === this.CitySelected
      }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
    }
  
    
    showbutton()
    {
      // Admin and Super Admin validation
      if(this.RoleSelected == 1 || this.RoleSelected == 2) {
        if(this.selectedCityId.length === 0 || this.selectedWorklocation.length === 0 || !this.PracticeSelected) {
          return true; // Disable button
        }
        return false; // Enable button
      }

      // User and Security Supervisor validation
      if(this.RoleSelected == 3 || this.RoleSelected == 4) {
        // If Approver is selected, L1 or L2 must be checked
        if(this.isApprover && !this.isL1 && !this.isL2) {
          return true; // Disable button
        }

        // If L1 is selected, validate L1 fields
        if(this.isL1) {
          if(this.selectedL1City.length === 0 || this.selectedL1Worklocation.length === 0 || this.selectedL1Practice.length === 0) {
            return true; // Disable button - L1 fields incomplete
          }
        }

        // If L2 is selected, validate L2 fields
        if(this.isL2) {
          if(this.selectedL2City.length === 0 || this.selectedL2Worklocation.length === 0 || this.selectedL2Practice.length === 0) {
            return true; // Disable button - L2 fields incomplete
          }
        }

        // If Requestor only (no Approver) - must have city and work location
        if(this.isRequestor && !this.isApprover) {
          if(this.selectedCityId.length === 0 || this.selectedWorklocation.length === 0) {
            return true; // Disable button
          }
          return false; // Enable button
        }

        // If both Requestor and Approver selected
        if(this.isRequestor && this.isApprover) {
          // Approver fields (L1/L2) are already validated above
          // Only validate Requestor fields IF they have started filling them
          // If user clicks Requestor after Approver is complete, allow submission even if Requestor fields are empty
          // But if they started filling Requestor fields, both city and work location must be complete
          if(this.selectedCityId.length > 0 || this.selectedWorklocation.length > 0) {
            // User started filling Requestor fields, both must be complete
            if(this.selectedCityId.length === 0 || this.selectedWorklocation.length === 0) {
              return true; // Disable button - Requestor fields partially filled
            }
          }
          return false; // Enable button (Approver validations passed, Requestor either not started or complete)
        }

        // If only Approver (no Requestor)
        if(!this.isRequestor && this.isApprover) {
          return false; // Enable button (L1/L2 validations already done above)
        }

        // If neither Requestor nor Approver selected
        if(!this.isRequestor && !this.isApprover) {
          return true; // Disable button
        }
      }
       
      return true; // Default: disable button
    }
      
  //On office change will load the gate and floor
  OnchangeOffice(event) {
    // let item=this.officeData.find(x=>x.officeID==this.OfficeSelected);
    // this.selectedWorklocation.push(item);
    // this.officeData=this.officeData.filter(x=>x.officeID!=item.officeID).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
   
  }

  // ============ L1 Approver Methods ============
  selectL1City() {
    let item = this.L1cityData.find(x => x.cityID == this.L1CitySelected);
    if (item && this.selectedL1City.indexOf(item) === -1) {
      this.selectedL1City.push(item);
      this.L1cityData = this.L1cityData.filter(x => x.cityID !== item.cityID).sort((item1, item2) => (item1.cityName < item2.cityName) ? -1 : 1);
    }
    
    this.L1officeData = this.MasterList.officeList
      .filter((office) => this.selectedL1City.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedL1Worklocation.some(worklocation => worklocation.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
    
    this.L1CitySelected = null;
  }

  removeL1City(item) {
    this.selectedL1City = this.selectedL1City.filter(x => x.cityID !== item.cityID);
    this.L1cityData.push(item);
    this.L1cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
    
    this.selectedL1Worklocation = this.selectedL1Worklocation.filter(x => x.cityID !== item.cityID);
    this.L1officeData = this.MasterList.officeList
      .filter((office) => this.selectedL1City.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedL1Worklocation.some(worklocation => worklocation.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }

  selectL1WorkLocation() {
    let item = this.L1officeData.find(x => x.officeID == this.L1OfficeSelected);
    if (item && this.selectedL1Worklocation.indexOf(item) === -1) {
      this.selectedL1Worklocation.push(item);
      this.L1officeData = this.L1officeData.filter(x => x.officeID !== item.officeID).sort((item1, item2) => (item1.officeName < item2.officeName) ? -1 : 1);
    }
    this.L1OfficeSelected = null;
  }

  removeL1WorkLocation(item) {
    this.selectedL1Worklocation = this.selectedL1Worklocation.filter(x => x.officeID !== item.officeID);
    this.L1officeData.push(item);
    this.L1officeData.sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }

  selectL1Practice() {
    let item = this.L1practiceData.find(x => x.practiceId == this.L1PracticeSelected);
    if (item && this.selectedL1Practice.indexOf(item) === -1) {
      this.selectedL1Practice.push(item);
      this.L1practiceData = this.L1practiceData.filter(x => x.practiceId !== item.practiceId).sort((item1, item2) => (item1.name < item2.name) ? -1 : 1);
    }
    this.L1PracticeSelected = null;
  }

  removeL1Practice(item) {
    this.selectedL1Practice = this.selectedL1Practice.filter(x => x.practiceId !== item.practiceId);
    this.L1practiceData.push(item);
    this.L1practiceData.sort((item1, item2) => (item1.name < item2.name ? -1 : 1));
  }

  // ============ L2 Approver Methods ============
  selectL2City() {
    let item = this.L2cityData.find(x => x.cityID == this.L2CitySelected);
    if (item && this.selectedL2City.indexOf(item) === -1) {
      this.selectedL2City.push(item);
      this.L2cityData = this.L2cityData.filter(x => x.cityID !== item.cityID).sort((item1, item2) => (item1.cityName < item2.cityName) ? -1 : 1);
    }
    
    this.L2officeData = this.MasterList.officeList
      .filter((office) => this.selectedL2City.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedL2Worklocation.some(worklocation => worklocation.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
    
    this.L2CitySelected = null;
  }

  removeL2City(item) {
    this.selectedL2City = this.selectedL2City.filter(x => x.cityID !== item.cityID);
    this.L2cityData.push(item);
    this.L2cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
    
    this.selectedL2Worklocation = this.selectedL2Worklocation.filter(x => x.cityID !== item.cityID);
    this.L2officeData = this.MasterList.officeList
      .filter((office) => this.selectedL2City.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedL2Worklocation.some(worklocation => worklocation.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }

  selectL2WorkLocation() {
    let item = this.L2officeData.find(x => x.officeID == this.L2OfficeSelected);
    if (item && this.selectedL2Worklocation.indexOf(item) === -1) {
      this.selectedL2Worklocation.push(item);
      this.L2officeData = this.L2officeData.filter(x => x.officeID !== item.officeID).sort((item1, item2) => (item1.officeName < item2.officeName) ? -1 : 1);
    }
    this.L2OfficeSelected = null;
  }

  removeL2WorkLocation(item) {
    this.selectedL2Worklocation = this.selectedL2Worklocation.filter(x => x.officeID !== item.officeID);
    this.L2officeData.push(item);
    this.L2officeData.sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }

  selectL2Practice() {
    let item = this.L2practiceData.find(x => x.practiceId == this.L2PracticeSelected);
    if (item && this.selectedL2Practice.indexOf(item) === -1) {
      this.selectedL2Practice.push(item);
      this.L2practiceData = this.L2practiceData.filter(x => x.practiceId !== item.practiceId).sort((item1, item2) => (item1.name < item2.name) ? -1 : 1);
    }
    this.L2PracticeSelected = null;
  }

  removeL2Practice(item) {
    this.selectedL2Practice = this.selectedL2Practice.filter(x => x.practiceId !== item.practiceId);
    this.L2practiceData.push(item);
    this.L2practiceData.sort((item1, item2) => (item1.name < item2.name ? -1 : 1));
  }

  //Add user 
  onSubmit(addDetails) {
    console.log('onSubmit called');
    console.log('EmployeeFullName:', this.EmployeeFullName);
    console.log('adduserDetails before validation:', this.adduserDetails);
    
    if(this.CitySelected==null && this.selectedCityId && this.selectedCityId.length > 0)
    {
     this.CitySelected= this.selectedCityId[0].cityID;
    }
    var userName = localStorage.getItem('email');
    if(this.EmployeeFullName == undefined){
      this.toast.error('Please enter UserName!');
      return; // Stop execution if username is not entered
    }
    
    // Validate that EmailId, FirstName, LastName are populated
    if(!this.adduserDetails.EmailId || !this.adduserDetails.FirstName || !this.adduserDetails.LastName) {
      this.toast.error('Please select a valid user from the dropdown!');
      console.error('Missing user details:', {
        EmailId: this.adduserDetails.EmailId,
        FirstName: this.adduserDetails.FirstName,
        LastName: this.adduserDetails.LastName
      });
      return; // Stop execution if user details are missing
    }

    //if(this.RoleSelected == 3)
    {
      for(let i=0;i<this.selectedWorklocation.length;i++){
        this.office= new UserOffices();
        this.office.officeID=this.selectedWorklocation[i].officeID;
        this.office.AddedBy= userName;
        this.office.ChangedBy= userName;
        this.office.IsActive=true;
        this.office.IsRequestor=this.isRequestor;
        this.office.isL1=false;
        this.office.isL2=false;
        this.UserOffices.push(this.office);
      }
    }
    // else{
    //     this.office= new UserOffices();
    //     this.office.AddedBy= userName;
    //     this.office.ChangedBy= userName;
    //     // this.office.officeID.push(this.OfficeSelected);
    //     this.a[0]=this.OfficeSelected;
    //     this.office.officeID =this.a[0];
    //     this.office.IsActive=true;
    //     this.UserOffices.push(this.office);  
    // }
    if (this.adduserform.valid) {
      // if (this.selectAdminRole.isChecked) {
      //   this.adduserDetails.RoleId = this.MasterList.applicationRole.find(x=> x.appRoleName == Role.Admin).appRoleId;
      // }
      // else  if (this.selectSupervisorRole.isChecked) {
      //   this.adduserDetails.RoleId =  this.MasterList.applicationRole.find(x=> x.appRoleName == Role.ShiftSupervisior).appRoleId;
      // }
      // else{
      //   // For badge Executive
      //   this.adduserDetails.RoleId =  this.MasterList.applicationRole.find(x=> x.appRoleName == Role.BadgeExecutive).appRoleId;
      // }
      if (this.selectActiveStatus.isChecked) {
        this.adduserDetails.isActive = true
      }
      else {
        this.adduserDetails.isActive = false
      }
      this.adduserDetails.dateAdded = new Date();
      this.adduserDetails.cityID = this.CitySelected;
      this.adduserDetails.RoleID = this.RoleSelected;
      this.adduserDetails.IsApprover = this.isApprover;
      this.adduserDetails.IsRequestor = this.isRequestor;
      
      // For Admin and Super Admin: set isL1 and isL2 to false, set practiceID to selected practice
      if(this.RoleSelected == 1 || this.RoleSelected == 2) {
        this.adduserDetails.isL1 = false;
        this.adduserDetails.isL2 = false;
        this.adduserDetails.practiceID = this.PracticeSelected;
        
        // Add practice to userPractices array for Admin/Super Admin
        if(this.PracticeSelected) {
          this.practice = new UserPractices();
          this.practice.PracticeId = this.PracticeSelected;
          this.practice.AddedBy = userName;
          this.practice.ChangedBy = userName;
          this.practice.IsActive = true;
          this.practice.isL1 = false;
          this.practice.isL2 = false;
          this.UserPractices.push(this.practice);
        }
      } else {
        // For User and Security Supervisor: set isL1/isL2 from checkboxes
        this.adduserDetails.isL1 = this.isL1;
        this.adduserDetails.isL2 = this.isL2;
        
        // Set practiceID to first L1 practice, or first L2 practice if no L1, or 0 if no practices
        if(this.selectedL1Practice.length > 0) {
          this.adduserDetails.practiceID = this.selectedL1Practice[0].practiceId;
        } else if(this.selectedL2Practice.length > 0) {
          this.adduserDetails.practiceID = this.selectedL2Practice[0].practiceId;
        } else {
          this.adduserDetails.practiceID = 0;
        }
      }
      
      // Build userPractices array for L1
      if(this.isL1 && this.selectedL1Practice.length > 0) {
        for(let i = 0; i < this.selectedL1Practice.length; i++) {
          this.practice = new UserPractices();
          this.practice.PracticeId = this.selectedL1Practice[i].practiceId;
          this.practice.AddedBy = userName;
          this.practice.ChangedBy = userName;
          this.practice.IsActive = true;
          this.practice.isL1 = true;
          this.practice.isL2 = false;
          this.UserPractices.push(this.practice);
        }
      }
      
      // Build userPractices array for L2
      if(this.isL2 && this.selectedL2Practice.length > 0) {
        for(let i = 0; i < this.selectedL2Practice.length; i++) {
          this.practice = new UserPractices();
          this.practice.PracticeId = this.selectedL2Practice[i].practiceId;
          this.practice.AddedBy = userName;
          this.practice.ChangedBy = userName;
          this.practice.IsActive = true;
          this.practice.isL1 = false;
          this.practice.isL2 = true;
          this.UserPractices.push(this.practice);
        }
      }
      
      // Add L1 offices to UserOffices array
      if(this.isL1 && this.selectedL1Worklocation.length > 0) {
        for(let i = 0; i < this.selectedL1Worklocation.length; i++) {
          this.office = new UserOffices();
          this.office.officeID = this.selectedL1Worklocation[i].officeID;
          this.office.AddedBy = userName;
          this.office.ChangedBy = userName;
          this.office.IsActive = true;
          this.office.IsRequestor = false;
          this.office.isL1 = true;
          this.office.isL2 = false;
          this.UserOffices.push(this.office);
        }
      }
      
      // Add L2 offices to UserOffices array
      if(this.isL2 && this.selectedL2Worklocation.length > 0) {
        for(let i = 0; i < this.selectedL2Worklocation.length; i++) {
          this.office = new UserOffices();
          this.office.officeID = this.selectedL2Worklocation[i].officeID;
          this.office.AddedBy = userName;
          this.office.ChangedBy = userName;
          this.office.IsActive = true;
          this.office.IsRequestor = false;
          this.office.isL1 = false;
          this.office.isL2 = true;
          this.UserOffices.push(this.office);
        }
      }
      
      //this.adduserDetails.dateAdded = this.dateAdded;     
      this.adduserDetails.addedBy = userName;
      this.adduserDetails.changedBy = userName;
      
      // Log user details to check if EmailId, FirstName, LastName are populated
      console.log('User Details:', this.adduserDetails);
      console.log('UserOffices:', this.UserOffices);
      console.log('UserPractices:', this.UserPractices);
      
     // Set officeID and cityID from requestor locations, or fallback to L1/L2 locations
      if(this.selectedWorklocation.length > 0) {
        this.adduserDetails.officeID = this.selectedWorklocation[0].officeID;
        this.adduserDetails.cityID = this.selectedWorklocation[0].cityID;
      } else if(this.selectedL1Worklocation.length > 0) {
        this.adduserDetails.officeID = this.selectedL1Worklocation[0].officeID;
        this.adduserDetails.cityID = this.selectedL1Worklocation[0].cityID;
      } else if(this.selectedL2Worklocation.length > 0) {
        this.adduserDetails.officeID = this.selectedL2Worklocation[0].officeID;
        this.adduserDetails.cityID = this.selectedL2Worklocation[0].cityID;
      } else {
        this.adduserDetails.officeID = null;
        this.adduserDetails.cityID = null;
      }
      this.userService.AddUsersData(this.adduserDetails, this.UserOffices, this.UserPractices)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          resultArray => {
            if (resultArray.userID == -1) {
              this.toast.error('Unable to save user details!');
              this.modalRef.hide();
            }
            else if(resultArray.userID == 0) {
              this.toast.error('User already exists');
              this.modalRef.hide();
            }
            else {
              this.toast.success('User added Suceessfully');
              this.userService.refreshwithFilters.next();
              this.modalRef.hide();
              this.userService.refreshwithFilters.next();
            }
          });
    }
    else {
      this.toast.error('Unable to save user details!');
    }
  }

  //typeheadcode
  onTravellerNameSeach() {
    this.requestorNameDataSource = Observable.create((observer: any) => {
      let txt = this.EmployeeFullName;
        let url = this.service_URL.Users.graphApi;
        let param = new HttpParams ().set("key",txt);
          this._dataContextService.GetwithValues<any>(url, null,param)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(result => {
          this.travellerNameArray = result;
          observer.next(result);
        }); 
      this.requestorNameChanged = true;
    }).pipe(mergeMap((token: string) => this.getRequestorNamesData(token)));
  }

   getRequestorNamesData(token: string): Observable<any> {

    let query = new RegExp(token, 'ig');
    return of(
      this.travellerNameArray.filter((obj: any) => {
        let hostObj = query.test(obj.displayName)
        return obj;
      })
    );
  } 
  changeRequestorTypeaheadLoading(e: boolean): void {
    if (this.requestorNameChanged != false) {
      this.typeaheadRequestorLoading = e;
    }
  }

  //On selection of particular value
  requestorNameOnSelect(e: TypeaheadMatch): void {   
    this.EmployeeFullName = e.item.displayName;
    // Call onselectClient to populate user details (EmailId, FirstName, LastName)
    this.onselectClient(e.item);
  }

  typeaheadTravelerNoResults(event: boolean): void {   
    this.EmployeeFirstName = undefined;
    this.EmployeeLastName = undefined;
    this.EmployeeAlias = undefined    
    this.Department == undefined
    this.noResultTravelerName = event;

  }

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
